import { render } from "./HomeBody4.vue?vue&type=template&id=278228b8&scoped=true"
import script from "./HomeBody4.vue?vue&type=script&lang=js"
export * from "./HomeBody4.vue?vue&type=script&lang=js"

import "./HomeBody4.vue?vue&type=style&index=0&id=278228b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278228b8"]])

export default __exports__